import {Action} from "@ngrx/store";

export const LOAD_KNOWLEDGE_BASE: string = '[knowledgeBase] Load Knowledge Base';
export const TOGGLE_KNOWLEDGE_BASE: string = '[knowledgeBase] Toggle Knowledge Base';

export class LoadKnowledgeBase implements Action {

  readonly type: string = LOAD_KNOWLEDGE_BASE;

}


export class ToggleKnowledgeBase implements Action {

  readonly type: string = TOGGLE_KNOWLEDGE_BASE;
  constructor(public payload?: any) {}

}

export type KnowledgeBaseAction = LoadKnowledgeBase | ToggleKnowledgeBase;
